var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('title-header'),_vm._t("info-cards"),_c('v-card',{staticClass:"page-default-card pt-7"},[_vm._t("table")],2)],2)}
var staticRenderFns = []

export { render, staticRenderFns }